import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfUsePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-mystical theme-bg-background">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <div
          style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: '1rem',
            padding: '2.5rem',
          }}
        >
          <Link to="/" className="text-purple-300 hover:text-white text-sm mb-6 inline-block">← Voltar</Link>
          <h1 className="text-3xl font-bold text-white mb-2">Termos de Uso</h1>
          <p className="text-white/40 text-sm mb-8">Última atualização: junho de 2025</p>

          <div className="space-y-8 text-white/80 leading-relaxed text-justify">
            <section>
              <h2 className="text-lg font-semibold text-white mb-3">1. Aceitação dos Termos</h2>
              <p>
                Ao acessar ou usar o <strong className="text-white">Astralyz</strong> (www.astralyz.com.br),
                você concorda com estes Termos de Uso. Se não concordar com qualquer parte destes termos,
                não utilize a plataforma.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">2. Descrição do Serviço</h2>
              <p>
                O Astralyz é uma plataforma digital de entretenimento e autoconhecimento que oferece
                consultas de tarot, astrologia, numerologia e outras práticas esotéricas mediadas por
                inteligência artificial (Aurora Lyz). O serviço é fornecido exclusivamente para fins de
                entretenimento, reflexão pessoal e autoconhecimento.
              </p>
              <p className="mt-3">
                <strong className="text-white">Aviso importante:</strong> As interpretações fornecidas pelo
                Astralyz não constituem aconselhamento profissional de saúde, psicológico, financeiro,
                jurídico ou de qualquer outra natureza. Decisões importantes devem ser tomadas com base em
                orientação profissional qualificada.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">3. Cadastro e Conta</h2>
              <p>
                Para acessar os serviços pagos do Astralyz, é necessário criar uma conta com e-mail e senha.
                Você é responsável por manter a confidencialidade de suas credenciais de acesso e por todas
                as atividades realizadas em sua conta.
              </p>
              <p className="mt-3">
                É proibido criar múltiplas contas com o objetivo de obter tokens gratuitos ou burlar
                quaisquer limites do serviço. O Astralyz se reserva o direito de encerrar contas que
                violem esta regra.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">4. Tokens e Pagamentos</h2>
              <p>
                O acesso às consultas é realizado mediante o uso de tokens. Tokens podem ser adquiridos
                por meio de pagamento (PIX) ou concedidos gratuitamente pelo Astralyz em promoções e
                no ato do cadastro.
              </p>
              <p className="mt-3">
                Tokens adquiridos via pagamento não são reembolsáveis após o uso. Tokens não utilizados
                não possuem prazo de expiração enquanto a conta estiver ativa.
              </p>
              <p className="mt-3">
                Os preços dos tokens podem ser alterados a qualquer momento, sem aviso prévio, mas sem
                afetar tokens já adquiridos.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">5. Propriedade Intelectual</h2>
              <p>
                Todo o conteúdo gerado pelo Astralyz — incluindo textos de interpretação, layouts,
                identidade visual e o personagem Aurora Lyz — é propriedade exclusiva da plataforma.
                É proibida a reprodução, distribuição ou comercialização sem autorização prévia e escrita.
              </p>
              <p className="mt-3">
                As imagens das cartas de tarot utilizadas são baseadas no baralho Rider-Waite, cujos
                elementos visuais originais são de domínio público.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">6. Conduta do Usuário</h2>
              <p>É proibido utilizar o Astralyz para:</p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-white/70">
                <li>Tentar acessar ou comprometer a segurança da plataforma</li>
                <li>Usar a plataforma para fins ilegais ou prejudiciais a terceiros</li>
                <li>Criar conteúdo ofensivo, discriminatório ou que viole direitos de terceiros</li>
                <li>Realizar engenharia reversa ou extração automatizada de dados</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">7. Limitação de Responsabilidade</h2>
              <p>
                O Astralyz não se responsabiliza por decisões tomadas com base nas interpretações
                fornecidas pela plataforma. O serviço é oferecido "como está", sem garantias de
                disponibilidade ininterrupta ou ausência de erros.
              </p>
              <p className="mt-3">
                Em nenhuma hipótese a responsabilidade total do Astralyz perante o usuário excederá
                o valor pago pelos tokens utilizados na consulta em questão.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">8. Privacidade</h2>
              <p>
                O uso dos seus dados pessoais é regido pela nossa{' '}
                <Link to="/politica-de-privacidade" className="text-purple-300 hover:text-white underline">
                  Política de Privacidade
                </Link>
                , em conformidade com a LGPD (Lei nº 13.709/2018).
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">9. Alterações nos Termos</h2>
              <p>
                Estes termos podem ser atualizados periodicamente. Mudanças significativas serão
                comunicadas por e-mail ou por aviso na plataforma. O uso continuado após a notificação
                implica aceitação dos novos termos.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">10. Contato</h2>
              <p>
                Para dúvidas sobre estes Termos de Uso, entre em contato pelo e-mail:{' '}
                <a href="mailto:contato@astralyz.com.br" className="text-purple-300 hover:text-white">
                  contato@astralyz.com.br
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUsePage;
